import * as React from 'react';
import { Link } from 'react-router-dom';
import { ProfileContext, Profile } from '../profile';
const isAdmin = (profile: Profile) => profile.type === 'admin';

export default () => {
  const { profile } = React.useContext(ProfileContext);
  const [shown, setShown] = React.useState(false);

  if (!profile) {
    return (
      <header className="w-100 sans-serif bg-white black bg-white bb bw b--black-10">
        <div className="mw9 ml-auto mr-auto flex justify-center items-center ph2 ph4-ns">
          <Link to="/dashboard" className="db tc link black dim ma3">
            <img
              className="br2 h2 w2 db"
              src="/images/filtru.png"
              alt="Filtru Business"
            />
          </Link>
        </div>
      </header>
    );
  }

  const routes: any = {
    dashboard: 'Dashboard',
    guides: 'Brew Guides',
    company: 'Brand Page',
  };

  if (profile.company) {
    routes.orders = 'Orders';
    routes.products = 'Products';
    routes['shipping-methods'] = 'Shipping';
    routes['sales-reports'] = 'Sales Reports';
    routes.billing = 'Billing';
    routes.invitations = 'Invite members';
  }

  if (isAdmin(profile)) {
    routes.feeds = 'Feeds';
    routes.contracts = 'Contracts';
    routes.categories = 'Categories';
  }

  return (
    <header className="w-100 sans-serif bg-white black bg-white bb bw b--black-10 pa3 no-print">
      <div className="mw9 ml-auto mr-auto ph2-m ph4-l">
        <div className="flex flex-column flex-row-l items-center-l">
          <div className="flex items-center">
            <Link
              to="/dashboard"
              className="db tc link black dim pr3"
              onClick={() => setShown(false)}
            >
              <img
                className="br2 h2 w2 db"
                src="/images/filtru.png"
                alt="Filtru Business"
              />
            </Link>
            <button
              className="tl bn link db dn-l pa3 black br3 hover-bg-near-white bg-white b pointer"
              type="button"
              onClick={() => setShown(!shown)}
            >
              Menu ‣
            </button>
          </div>
          <menu
            className={`${
              shown ? 'flex' : 'dn'
            } flex-l flex-column flex-row-l items-center-l flex-auto list pl0 ma0 mt3 mt0-l`}
          >
            {Object.keys(routes).map((key: string) => (
              <Link
                to={`/${key}`}
                className="b db link black pa3 br3 hover-bg-near-white bg-white"
                onClick={() => setShown(false)}
              >
                {routes[key]}
              </Link>
            ))}
            <div className="flex-auto"></div>
            <Link
              to="/profile"
              className="b db link black pa3 pa0-l br3 hover-bg-near-white bg-white"
              onClick={() => setShown(false)}
            >
              <p className="ma0">{profile.name}</p>
              {profile.company && (
                <span className="normal f7">{profile.company.name}</span>
              )}
            </Link>
          </menu>
        </div>
      </div>
    </header>
  );
};
